export default "__VITE_ASSET__058781d7__"